import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import ListingComponent from "./listing.page";
import { NEW_PRODUCT_PAGE, GENERATE_PRODUCT } from "../../config/product-mgmt.route";
import {AccessRights} from "lib/constants/accessRights"
import { resetProductPage } from "../../redux/slice/productPage.slice";
import { ROOT } from "modules/product-mgmt";
import { getLang } from "app/feature/constants";
import LoadingComponent from "components/loading";
import qs from "query-string";
import { openCreationDialog, closeCreationDialog, disableCategoryQuickEdit } from "modules/product-mgmt/redux/slice/products.slice.js";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function ListingContainer({
  history,
  resetProductPage
}) {
  const location = useLocation();
  const dispatch = useDispatch();
  const isCategoryEdit = false;
  const hasProductModuleAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.MODULE));
  const hasProductViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.LISTING_READ));
  const hasProductCategorytViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.CATEGORY_READ));
  const hasProductBrandModelViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.BRAND_MODEL_READ));
  const hasProductAttributeViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.ATTRIBUTE_READ));
  const hasProductAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.LISTING_CREATE));
  const hasProductCategoryAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.CATEGORY_CREATE));
  const hasProductAttributeAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.ATTRIBUTE_CREATE));
  const hasProductBrandModelAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.BRAND_MODEL_CREATE));
  const hasProductTemplateViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.LANDING_TEMPLATE_READ));
  const hasProductTemplateAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Product.LANDING_TEMPLATE_CREATE));
  const lang = useSelector(state => state.constant.languages);
  const [activeIndex, setActiveIndex] = useState(0);
  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.tab || '';

  useEffect(()=>{
    if(!hasProductModuleAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasProductModuleAccessRight])

  useEffect(() => {
    let tempIndex = 0;
    switch (currentSearch) {
      case "productList":
        tempIndex = 0;
        break;
      case "category":
        tempIndex = 1;
        break;
      case "brandModel":
        tempIndex = 2;
        break;
      case "attribute":
        tempIndex = 3;
        break;
      case "landingPageTemplate":
        tempIndex = 4;
        break
      default:
        tempIndex = 0;
    }
    setActiveIndex(tempIndex);
  }, [currentSearch]);

  if (!hasProductModuleAccessRight) return <LoadingComponent />;

  let tabLabels = [];
  if (hasProductModuleAccessRight) {
    if (hasProductViewAccessRight) tabLabels.push(getLang(lang, "label.PRODUCT_LIST"));
    if (hasProductCategorytViewAccessRight) tabLabels.push(getLang(lang, "label.CATEGORY_LIST"));
    if (hasProductBrandModelViewAccessRight) tabLabels.push(getLang(lang, "label.BRAND_MODEL_LIST"));
    if (hasProductAttributeViewAccessRight) tabLabels.push(getLang(lang, "label.ATTRIBUTE_LIST"));
    if (hasProductTemplateViewAccessRight) tabLabels.push(getLang(lang, "label.LANDING_PAGE_TEMPLATES"))
  }

  const handleChange = (event, index) => {
    setActiveIndex(index);
    history.replace({
      pathname: ROOT,
      search: `?tab=${
        index === 0 ? 'productList' 
        : index === 1 ? 'category' 
        : index === 2 ? 'brandModel'
        : index === 3 ? 'attribute'
        : 'landingPageTemplate'
      }`
    })
  };

  const handleCreate = () => {
    resetProductPage();
    history.push(NEW_PRODUCT_PAGE);
  };

  const handleGenerateProduct = () => {
    history.push(GENERATE_PRODUCT)
  }

  const disableCategoryEdit = () => {
    dispatch(disableCategoryQuickEdit())
  }
  const handleAdd = (value) => {
    if (value) {
      dispatch(openCreationDialog());
    } else {
      dispatch(closeCreationDialog());
    }
  };

  return (
    <>
      <ListingComponent
        disableCategoryEdit={disableCategoryEdit}
        hasProductAddAccessRight={hasProductAddAccessRight}
        handleCreate={handleCreate}
        handleGenerateProduct={handleGenerateProduct}
        handleAdd={handleAdd}
        hasProductCategoryAddAccessRight={hasProductCategoryAddAccessRight}
        isCategoryEdit={isCategoryEdit}
        hasProductAttributeAddAccessRight={hasProductAttributeAddAccessRight}
        hasProductBrandModelAddAccessRight={hasProductBrandModelAddAccessRight}
        hasProductTemplateAddAccessRight={hasProductTemplateAddAccessRight}
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        lang={lang}
      />
    </>
  );
}

const mapDispatchToProps = dispatch => ({
  resetProductPage: () => dispatch(resetProductPage())
});

export default connect(null, mapDispatchToProps)(ListingContainer);
